const API_BASE = '/api';

async function request(path: string, options: RequestInit = {}) {
  const token = localStorage.getItem('auth_token');
  const headers: Record<string, string> = {
    ...options.headers as Record<string, string>,
  };
  if (token) headers['Authorization'] = `Bearer ${token}`;
  if (!(options.body instanceof FormData)) {
    headers['Content-Type'] = 'application/json';
  }

  const res = await fetch(`${API_BASE}${path}`, { ...options, headers });

  if (res.status === 401) {
    localStorage.removeItem('auth_token');
    localStorage.removeItem('auth_user');
    // Redirect to main domain on session expiry
    const isAppDomain = window.location.hostname === 'app.vavassori.arq.br';
    window.location.href = isAppDomain ? 'https://vavassori.arq.br' : '/';
    throw new Error('Unauthorized');
  }

  if (res.status === 204) return null;

  const data = await res.json();
  if (!res.ok) throw new Error(data.error?.message || 'Erro na requisição');
  return data;
}

export const api = {
  get: (path: string) => request(path),
  post: (path: string, body?: unknown) => request(path, { method: 'POST', body: body instanceof FormData ? body : JSON.stringify(body) }),
  put: (path: string, body: unknown) => request(path, { method: 'PUT', body: JSON.stringify(body) }),
  patch: (path: string, body: unknown) => request(path, { method: 'PATCH', body: JSON.stringify(body) }),
  delete: (path: string) => request(path, { method: 'DELETE' }),
};

// Empreendimentos
export function listarEmpreendimentos(tipo?: 'projeto' | 'obra') {
  const query = tipo ? `?tipo=${tipo}` : '';
  return api.get(`/empreendimentos${query}`);
}

export function criarEmpreendimento(data: any) {
  return api.post('/empreendimentos', data);
}

export function editarEmpreendimento(id: string, data: any) {
  return api.put(`/empreendimentos/${id}`, data);
}

export function buscarEmpreendimento(id: string) {
  return api.get(`/empreendimentos/${id}`);
}

// Tipos de Etapa com filtro de categoria
export function listarTiposEtapa(categoria?: 'projeto' | 'obra') {
  const query = categoria ? `?categoria=${categoria}` : '';
  return api.get(`/tipos-etapa${query}`);
}

export function criarTipoEtapa(data: any) {
  return api.post('/tipos-etapa', data);
}

export function editarTipoEtapa(id: string, data: any) {
  return api.put(`/tipos-etapa/${id}`, data);
}
